import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


let CBOCustomerSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_DOM_ID',
                id_ui: 'DOMAIN_ID',
                name:  'DOMAIN_NAME'},

    searchProviderFields: {
        WB_CUST_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
        CUSTOMER_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        CUSTOMER_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        CUSTOME_TYPE:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Type', columnResourceName: 'colType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1333}},
        SOURCE_ID:       {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Source Id', columnResourceName: 'colSource', alignment: HorizAlignment.Center}, domainOptions: {}}
    },


  search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
    return new Promise<any[]>((resolve, error) => {

      let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
        'vUI_CBOCustomerSearch',
        this.searchProviderFields,
        [])

      PASearch.findByRequest(findRequest)
        .then((res: any[]) => {
          resolve(res)
        })
        .catch((err)=> {
          error(err)
        })
    })
  }

}


let CBOCustomerSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "CBOCustomerSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'CUSTOMER_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME','CUSTOME_TYPE','SOURCE_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CBOCustomerSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var CBOCustomerSearch: ISearch = {
    searchName: "Find CBO Customer",
    renderOptions: { ui5ResourceId: "CBOCustomerSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [CBOCustomerSearchProfileByName]
}

PAEnvironment.registerBusinessObjectSearch("DomainBO", "CBOCustomerSearch", CBOCustomerSearch, "CBO Customer Search")

export {CBOCustomerSearch}
